import {getTestProps} from '@benchling/js-test-utils';
import {Flex} from '@mantine/core';
import React from 'react';

import * as ContextMenu from 'components/ContextMenu';
import GroupTitleBar from 'notebook/notes/groups/GroupTitleBar';
import {NoteLinkedGroupKind} from 'notebook/notes/groups/NoteLinkedGroupConstants';
import groupKindToIcon from 'notebook/notes/groups/util/groupKindToIcon';
import MantineOverflowMenu from 'ui-library/menus/MantineOverflowMenu';

export interface NotePartGridHeaderProps {
  groupName: string;
  rightHeaderControls?: JSX.Element | null;
  isCollapsed: boolean;
  onToggleCollapsed: () => void;
  onRename?: () => void;
  viewer?: boolean;
}

/**
 * Header for a NotePartGrid note part. Renders the shared GroupTitleBar so
 * NotePartGrid gets the same name/icon/collapse affordances as other
 * NoteLinkedGroup kinds.
 */
export default function NotePartGridHeader({
  groupName,
  rightHeaderControls,
  isCollapsed,
  onToggleCollapsed,
  onRename,
  viewer,
}: NotePartGridHeaderProps): JSX.Element {
  const handleContextMenu = (e: React.MouseEvent): void => {
    if (onRename == null) {
      return;
    }
    e.preventDefault();
    ContextMenu.view.open(e.nativeEvent, [{name: 'Rename...', click: onRename}]);
  };

  const headerControls =
    rightHeaderControls != null || onRename != null ? (
      <Flex align="center">
        {rightHeaderControls}
        {onRename != null && (
          <MantineOverflowMenu
            iconSize="sm"
            triggerTooltip="Image grid actions"
            sections={[{items: [{name: 'Rename...', onSelect: onRename}]}]}
          />
        )}
      </Flex>
    ) : null;

  return (
    <div {...getTestProps({component: 'NotePartGrid', element: 'header'})}>
      <GroupTitleBar
        groupName={groupName}
        icon={groupKindToIcon(NoteLinkedGroupKind.NOTE_PART_GRID)}
        rightHeaderControls={headerControls}
        isCollapsed={isCollapsed}
        onToggleCollapsed={onToggleCollapsed}
        onTitleContextMenu={onRename ? handleContextMenu : undefined}
        viewer={viewer}
        wrapGroupName={true}
      />
    </div>
  );
}
